import { PreloadedQuery } from 'react-relay';

import { createRelayResource } from '@townsquare/relay-utils';
import { RouteResource } from '@townsquare/router/routing-types';

import LookupRedirectActionGoalQuery, {
	LookupRedirectActionGoalQuery as LookupRedirectActionGoalQueryType,
} from './__generated__/LookupRedirectActionGoalQuery.graphql';
import LookupRedirectActionProjectQuery, {
	LookupRedirectActionProjectQuery as LookupRedirectActionProjectQueryType,
} from './__generated__/LookupRedirectActionProjectQuery.graphql';

export const lookupActionProjectResource: RouteResource<
	PreloadedQuery<LookupRedirectActionProjectQueryType, Record<string, unknown>>
> = createRelayResource<LookupRedirectActionProjectQueryType>({
	getQuery: (routerContext) => {
		const { key } = routerContext?.match?.params || {};
		return {
			query: LookupRedirectActionProjectQuery,
			variables: {
				entityKey: key || '',
			},
		};
	},
});

export const lookupActionGoalResource: RouteResource<
	PreloadedQuery<LookupRedirectActionGoalQueryType, Record<string, unknown>>
> = createRelayResource<LookupRedirectActionGoalQueryType>({
	getQuery: (routerContext) => {
		const { key } = routerContext?.match?.params || {};
		return {
			query: LookupRedirectActionGoalQuery,
			variables: {
				entityKey: key || '',
			},
		};
	},
});
